<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="EditActor"
    title="Edit Actor"
    submit-name="Save changes"
    :submit-disabled="!edited"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-input
      ref="inputName"
      label="Name"
      focus
      @input="onInput"
      @submit="submitFromInput"
    />
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'ModalEditActor',
  components: {
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      modalName: Modal.EDIT_ACTOR,
      modalRef: null,
      inputs: null,
      actorPathArr: null,
      edited: false
    }
  },
  computed: mapGetters(['selectedActor']),
  watch: {
    selectedActor() {
      this.updateInputData()
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.inputName]
    this.updateInputData()
  },
  methods: {
    updateInputData() {
      this.$refs.inputName.data = this.selectedActor?.name
    },
    async onInput(v) {
      this.edited = this.selectedActor?.name !== v
      await this.$nextTick()
      this.$refs.inputName.setFocus()
    },
    submitFromInput() {
      if (this.edited) this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('editActor', {name: this.$refs.inputName.data})
          .then(actorPathArr => {
            this.actorPathArr = actorPathArr
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        this.$router
          .push({
            name: 'info',
            params: {actor: this.actorPathArr}
          })
          .catch(error => error)
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.ACTOR_EDITED)
      }
    }
  }
}
</script>
